'use client';

import { colors } from '@galapagos/design-system/colors';
import { Text } from '@galapagos/design-system/web';
import QRCode from 'react-qr-code';
import { useTranslation } from 'react-i18next';
import { DOWNLOAD_QR_CLASS, DOWNLOAD_QR_SIZE } from '../../download/download-style';

export interface DownloadQrCardProps {
  scanUrl: string;
}

/**
 * The QR a member scans from a computer screen. It encodes one link that
 * opens the right store on whichever phone scans it, so the card shows only
 * at desktop width (the stylesheet hides it below the page-column breakpoint).
 */
export function DownloadQrCard({ scanUrl }: DownloadQrCardProps) {
  const { t } = useTranslation('signup');
  return (
    <div
      className={`signup-download__card ${DOWNLOAD_QR_CLASS}`}
      data-testid="signup-download-qr-card"
    >
      <div className="signup-download__qr-body">
        <QRCode
          className="signup-download__qr-code"
          value={scanUrl}
          size={DOWNLOAD_QR_SIZE}
          bgColor={colors.background.container}
          fgColor={colors.text.primary}
          role="img"
          aria-label={t('download.qr.label')}
          data-testid="signup-download-qr"
        />
        <div className="signup-download__qr-text">
          <Text variant="b2Bold" value={t('download.qr.title')} />
          <Text variant="b3Regular" color="secondary" value={t('download.qr.body')} />
        </div>
      </div>
    </div>
  );
}
